module.exports = __webpack_public_path__ + "img/엑소시스트.92268676.png";